import Dictionary from 'components/Dictionary';
import { connect } from 'react-redux';
import { compose } from 'redux';

import withPageLoader from 'components/withPageLoader';
import { redcapDictionary, updateRedcapDictionary } from 'store/actionCreators/dictionary';
import { getDictionaryLoading } from 'store/selectors/dictionary';

const mapStateToProps = ({ dictionary: { data } }) => ({
  dictionary: data,
});

const mapDispatchToProps = dispatch => ({
  getDictionary: () => dispatch(redcapDictionary()),
  submit: updatedDictionary => dispatch(updateRedcapDictionary(updatedDictionary)),
});

export default compose(
  withPageLoader({
    loadingSelector: getDictionaryLoading,
    initialAction: redcapDictionary,
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Dictionary);
